var map = {
	"./business-post-1.jpg": "e8f1",
	"./business-post-2.jpg": "50d7",
	"./business-post-3.jpg": "f94a",
	"./business-post-4.jpg": "69a5",
	"./business-post-5.jpg": "636d",
	"./business-post-6.jpg": "73bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e473";